// extracted by mini-css-extract-plugin
export default {"main-servicenumber":"configurator-web-main-servicenumber"};